var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-stage',{ref:"stage",attrs:{"config":_vm.configKonva}},[_c('v-layer',{ref:"layer"},[_c('v-line',{ref:"figure",attrs:{"config":{
						x: _vm.configKonva.width/2 - 900/2,
						y: 200,
						points: this.points,
						tension: 0.4,
						closed: true,
						fill: '#ffffff',
						shadowBlur: 20,
						shadowColor: 'rgba(134, 184, 227, 0.19)'
					  }}})],1),_vm._v(" "),_c('v-layer',{ref:"dragLayer"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc89a7e8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasy.vue
// module id = 4KD6
// module chunks = 0